import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import ModalHeader from "../../Components/Header/ModalHeader";
import { useNavigate } from "react-router-dom";
import "./IECVideoModal.scss";
import "../Master/MasterFormStyles.scss";
import {
  successToastStyle,
  errorToastStyle,
} from "../../Shared/Utils/ToastUtils";
import { toast } from "react-toastify";
import { MultiSelect } from "primereact/multiselect";
import { InputTextarea } from "primereact/inputtextarea";
import {
  addIECModule,
  clearSelectedItems,
  fetchIECViewData,
  updateIECModule,
} from "../../Store/IECModule/IECModuleAction";
import InputTextTranslation from "../../Shared/Component/Forms/InputTextTranslation";
import {
  addIECModuleSuperAdmin,
  approveIECModule,
  rejectIECModule,
  updateIECModuleSuperAdmin,
} from "../../Services/IECModuleService";
import { useLanguage } from "../ChangeLanguage/LanguageProvider";
import { useTranslation } from "react-i18next";
import {
  audienceOptions,
  typeOptions,
} from "../../Shared/Constant/TableConstants";
import UserRoles from "../../Shared/Constant/UserRoles";
const IECModuleForm = ({ data, updateId }) => {
  const dispatch = useDispatch();
  const [type, setType] = useState("");
  const [audience, setAudience] = useState([]);
  const [title, setTitle] = useState("");
  const [translatedTitle, setTranslatedTitle] = useState("");
  const [description, setDescription] = useState("");
  const [remarkData, setRemarkData] = useState("");
  const [uploadFile, setUploadFile] = useState(null);
  const [uploadFileName, setUploadFileName] = useState(null);
  const [uploadFileNameAfter, setUploadFileNameAfter] = useState("");
  const [isValidFormat, setIsValidFormat] = useState(false);
  const [remarkBlock, setRemarkBlock] = useState(false);
  const [categoryError, setCategoryError] = useState(false);
  const [audienceError, setAudienceError] = useState(false);
  const [videoPresentError, setVideoPresentError] = useState(false);
  const [uploadAttempted, setUploadAttempted] = useState(false);
  const [videoClearError, setVideoClearError] = useState(false);
  const fileInputref = useRef();
  const role = sessionStorage.getItem("userRole");
  const navigate = useNavigate();
  const { selectedLanguageId } = useLanguage();
  const { t } = useTranslation("Iec");
  const checkUp = type && audience.length > 0 && title && uploadFileNameAfter;
  const checkUpUpload = type && audience.length > 0 && title && uploadFile;
  function checkDataId(data) {
    return data && data.id;
  }
  const buttonLabel = checkDataId(data)
    ? "Update Video Module"
    : "Add Video Module";
  const isDisabled = checkDataId(data) ? !checkUp : !checkUpUpload;
  const isReject = checkDataId(data) ? "Reject Request" : "Clear";
  const displayErrorMessage = videoPresentError && !isValidFormat;
  const handleTranslatedTextChange = (englishText, translatedText) => {
    console.log("translatedText", englishText, translatedText);
  };
  useEffect(() => {
    if (data) {
      setType(data.categoryType);
      setAudience(data.audience);
      setTitle(data.videoTitle.english);
      setDescription(data.videoDescription);
      setUploadFileNameAfter(data.videoUrl);
      setTranslatedTitle(data.videoTitle.marathi);
    }
  }, [data]);
  const handleUploadAttempt = () => {
    setUploadAttempted(true);
  };
  const pathIEC = "/iecmodule";
  const validateVideoPresence = () => {
    const isVideoPresent =
      (uploadAttempted || videoClearError) &&
      !uploadFile &&
      !uploadFileNameAfter;
    setVideoPresentError(isVideoPresent);
  };
  useEffect(() => {
    validateVideoPresence();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadAttempted, uploadFile, uploadFileNameAfter, videoClearError]);
  const handleClear = () => {
    setType("");
    setAudience([]);
    setTitle("");
    setDescription("");
    setUploadFile(null);
    setUploadFileNameAfter("");
  };
  const handleCancelRemark = () => {
    setRemarkBlock(false);
    setRemarkData("");
  };
  const handleSubmitRemark = async () => {
    try {
      await rejectIECModule(updateId, remarkData);
      fetchIECViewData(dispatch, selectedLanguageId)();
      dispatch(clearSelectedItems());
      navigate(pathIEC);
    } catch (error) {
      console.error("Error rejecting IEC module:", error);
    }
  };
  const handleReject = () => {
    setRemarkBlock(true);
  };
  const handleApproveUpdate = async () => {
    try {
      if (checkUp) {
        await updateIECModuleSuperAdmin(
          updateId,
          type,
          audience,
          title,
          description,
          uploadFile,
          translatedTitle
        );
        await approveIECModule(updateId, remarkData);
        await fetchIECViewData(dispatch, selectedLanguageId)();
        toast.success(t("Video Module Updated Successfully"), {
          style: { width: "400px", ...successToastStyle },
        });
        dispatch(clearSelectedItems());
        navigate(pathIEC);
      }
    } catch (error) {
      toast.error("Video Module Updated Failed", {
        style: { width: "400px", ...errorToastStyle },
      });
    }
  };
  const onHide = () => {
    navigate(pathIEC);
    dispatch(clearSelectedItems());
  };
  const handleApproveAdd = async () => {
    try {
      if (checkUpUpload) {
        await addIECModuleSuperAdmin(
          type,
          audience,
          title,
          description,
          uploadFile,
          translatedTitle
        );
        toast.success(t("Video Module Added Successfully"), {
          style: { width: "400px", ...successToastStyle },
        });
        onHide();
        await fetchIECViewData(dispatch, selectedLanguageId)();
        dispatch(clearSelectedItems());
      }
    } catch (error) {
      toast.error(t("Video Module Add Failed"), {
        style: { width: "400px", ...errorToastStyle },
      });
    }
  };
  const handleAddVideoModule = async () => {
    if (checkUpUpload) {
      onHide();
      dispatch(
        addIECModule({
          type,
          audience,
          title,
          description,
          uploadFile,
          dispatch2: dispatch,
          selectedLanguageId,
          translatedTitle,
        })
      );
      toast.success(t("Video Module Added Successfully"), {
        style: { width: "400px", ...successToastStyle },
      });
      dispatch(clearSelectedItems());
    }
  };
  const handleUpdateVideoModule = async () => {
    if (checkUp) {
      dispatch(
        updateIECModule({
          updateId,
          type,
          audience,
          title,
          description,
          uploadFile,
          dispatch2: dispatch,
          selectedLanguageId,
          translatedTitle,
        })
      );
      toast.success(t("Video Module Updated Successfully"), {
        style: { width: "400px", ...successToastStyle },
      });
      dispatch(clearSelectedItems());
      onHide();
    }
  };
  const clickHandler = checkDataId(data)
    ? handleUpdateVideoModule
    : handleAddVideoModule;
  function extractFileNameFromUrl(url) {
    const parts = url.split("/");
    return parts[parts.length - 1];
  }
  const fileNameAfter = extractFileNameFromUrl(uploadFileNameAfter || "");
  const isFileUploaded = uploadFile !== null || fileNameAfter;
  const removeFile = () => {
    setUploadFile(null);
    setUploadFileName(null);
    setUploadFileNameAfter(null);
    fileInputref.current.value = null;
    setVideoClearError(true);
  };
  const setFileDetails = (event, setDocument, setDocumentName) => {
    const files = event.target.files;
    const fileName = event.target.files?.[0]?.name;
    setDocument(files[0]);
    setDocumentName(fileName);
    setUploadFileNameAfter(fileName);
  };
  const handleType = async (e) => {
    const value = e.value;
    setType(value);
    if (!value) {
      setCategoryError(true);
    } else {
      setCategoryError(false);
    }
  };
  const handleTypeBlur = (e) => {
    const value = e.value;
    if (!value) {
      setCategoryError(true);
    } else {
      setCategoryError(false);
    }
  };
  const handleAudienceName = (e) => {
    const selectedValues = e.value;
    setAudience(selectedValues);
    if (selectedValues.length === 0) {
      setAudienceError(true);
    } else {
      setAudienceError(false);
    }
  };
  const handleAudienceBlur = () => {
    if (audience.length === 0) {
      setAudienceError(true);
    } else {
      setAudienceError(false);
    }
  };
  const isFileSelected = uploadFile !== null || uploadFileNameAfter;
  const inputClassName = isFileSelected
    ? "flex justify-content-between p-inputtext p-component input-disabled"
    : "flex justify-content-between p-inputtext p-component input-style";

  return (
    <Dialog
      className="cockpit-dialog"
      visible
      modal={true}
      position={"center"}
      draggable={false}
      resizable={false}
      onHide={onHide}
      closeOnEscape={false}
      header={<ModalHeader onClose={onHide} backText={"Back To IEC"} />}
    >
      <div className="pl-3 pt-1 pr-3">
        <div className="flex flex-wrap align-items-center justify-content-between">
          <div className="form_title" data-testId="header-iecmoduleform">
            {data?.id ? "Update New Video Module" : "Add New Video Module"}
          </div>
        </div>
        <div className="master-form ">
          <div className="flex grid p-3 ">
            <div className="col-12 md:col-6 lg:col-3  flex-column flex">
              <label htmlFor="type" className="input-label">
                <span className="required-field">* </span>
                {t("CategoryTypeofVideo")}
              </label>
              <Dropdown
                id="type"
                value={type}
                options={typeOptions}
                onChange={handleType}
                onBlur={handleTypeBlur}
                placeholder="Select a category"
                className="input-style"
                data-testid="type-dropdown-cate"
              />
              <br />
              {categoryError && (
                <span style={{ color: "red" }}>Select a category</span>
              )}
            </div>
            <div className="col-12 md:col-6 lg:col-3  flex-column flex">
              <label htmlFor="audience" className="input-label">
                <span className="required-field">* </span>
                {t("Audience")}
              </label>
              <MultiSelect
                id="audience"
                value={audience}
                options={audienceOptions}
                key={audienceOptions.map((option) => option.value)}
                onChange={handleAudienceName}
                onBlur={handleAudienceBlur}
                placeholder="Select audience"
                className="input-style"
                filter
                display="chip"
                optionLabel="label"
                data-testId="audience-dropdown"
              />
              <br />
              {audienceError && (
                <span style={{ color: "red" }}>Select audience</span>
              )}
            </div>
            <div className="col-12 md:col-6 lg:col-3  flex-column flex">
              <InputTextTranslation
                label={t("VideoTitle")}
                asterisk="*"
                inputText={title}
                translatedText={translatedTitle}
                onChangeInputText={setTitle}
                onChangeTranslatedText={setTranslatedTitle}
                placeholder="Enter English text"
                type="text"
                onTranslatedTextChange={handleTranslatedTextChange}
                errors={{}}
                inputTextMeta={{}}
                translatedTextMeta={{}}
              />
            </div>
          </div>
          <div className="flex grid p-3">
            <div className="col-12 md:col-6 lg:col-5">
              <label htmlFor="description" className="input-label">
                {t("VideoDescription")}
              </label>
              <InputTextarea
                id="description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                className="input-style"
                style={{
                  width: "100%",
                  height: "90px",
                  whiteSpace: "pre-wrap",
                  overflow: "hidden",
                  resize: "none",
                }}
              />
            </div>
            <div className="col-12 md:col-6 lg:col-">
              <label htmlFor="upload" className="input-label">
                <span className="required-field">* </span>
                {t("UploadVideo")}
              </label>
              <div className="flex flex-wrap">
                <div>
                  <div>
                    <label htmlFor="getFile1">
                      <div
                        onClick={handleUploadAttempt}
                        className={inputClassName}
                      >
                        <div>
                          Choose File
                          <input
                            type="file"
                            id="getFile1"
                            accept="video/mp4,video/mov,video/mkv,video/webm"
                            onChange={(e) => {
                              const selectedFile = e.target.files[0];
                              const allowedFormats = [
                                "video/mp4",
                                "video/mov",
                                "video/mkv",
                                "video/webm",
                              ];
                              if (
                                selectedFile &&
                                allowedFormats.includes(selectedFile.type)
                              ) {
                                setFileDetails(
                                  e,
                                  setUploadFile,
                                  setUploadFileName
                                );
                                setIsValidFormat(false);
                              } else {
                                setIsValidFormat(true);
                              }
                            }}
                            ref={fileInputref}
                            className="hidden"
                            disabled={
                              uploadFile !== null || uploadFileNameAfter
                            }
                          />
                        </div>
                        <i
                          className="pi pi-upload"
                          style={{ fontSize: "1rem" }}
                        ></i>
                      </div>
                    </label>
                  </div>
                </div>
                {isFileUploaded && (
                  <div className="file_upload">
                    <div className="file_name">
                      {uploadFileName || fileNameAfter}{" "}
                    </div>
                    <Button
                      icon="pi pi-times"
                      rounded
                      text
                      severity="danger"
                      aria-label="Remove file"
                      tooltip="Remove file"
                      onClick={removeFile}
                      data-testId="remove-fileTest"
                    />
                  </div>
                )}{" "}
              </div>
              <span className="file_format">
                Supported Formats : MP4,MOV,MKV etc
              </span>
              <br />
              {isValidFormat && (
                <span style={{ color: "red" }}>Upload correct file format</span>
              )}
              {displayErrorMessage && (
                <span style={{ color: "red" }}>Select a Video</span>
              )}
            </div>
          </div>

          {role !== UserRoles.SUPERADMIN && (
            <div className="flex gap-3 mastersFormBtnGroup justify-content-center m-2">
              <Button
                className="formBtn-clear"
                label="Clear"
                data-testid="clear-button"
                onClick={handleClear}
                tooltip="Clear"
                tooltipOptions={{ position: "bottom", event: "both" }}
              />
              <Button
                className="formBtn-primary"
                label={buttonLabel}
                onClick={clickHandler}
                disabled={isDisabled}
                data-testid="addd-button"
              />
            </div>
          )}
          {role === UserRoles.SUPERADMIN && (
            <div className="flex gap-3 mastersFormBtnGroup justify-content-center m-2">
              <Button
                className="formBtn-deleteReq"
                label={isReject}
                data-testid="clearr-button"
                onClick={data?.id ? handleReject : handleClear}
                tooltip={isReject}
                tooltipOptions={{ position: "bottom", event: "both" }}
              />
              <Button
                className="formBtn-primary"
                label={data?.id ? "Approve Request" : "Add Video Module"}
                onClick={data?.id ? handleApproveUpdate : handleApproveAdd}
                data-testid="add-button"
                disabled={isDisabled}
              />{" "}
            </div>
          )}
        </div>{" "}
      </div>
      {remarkBlock && (
        <div className="pl-3 pt-1 pr-3">
          <div className="master-form">
            <div className="col-12 md:col-5 lg:col-5">
              <label htmlFor="description" className="input-label">
                <span className="required-field">* </span>Add Remark:
              </label>
              <InputTextarea
                id="remark"
                value={remarkData}
                onChange={(e) => setRemarkData(e.target.value)}
                className="input-style"
                style={{
                  width: "100%",
                  height: "60px",
                  whiteSpace: "pre-wrap",
                  overflow: "hidden",
                  resize: "none",
                  color: "#1D2965",
                  fontWeight: "500",
                }}
              />
            </div>
            <div className="flex gap-3 mastersFormBtnGroup justify-content-center m-2">
              <Button
                className="formBtn-clear"
                label="Cancel"
                data-testid="clear-button2"
                onClick={handleCancelRemark}
              />
              <Button
                className="formBtn-primary"
                label="Submit"
                onClick={handleSubmitRemark}
                data-testid="add-button"
              />
            </div>
          </div>
        </div>
      )}
    </Dialog>
  );
};
export default IECModuleForm;
